import { useId } from 'react';
import { Label } from '@clarix/ui';
import { AppSelect } from '@clarix/ui-shared';
import { QM_COPY } from './copy';
import type { QuickMeetingMicValue } from './useQuickMeetingMic';

interface MicPickerProps {
  mic: QuickMeetingMicValue;
  disabled?: boolean;
}

/** Which microphone records: the saved choice before a take, the device capturing during one. */
export function MicPicker({ mic, disabled = false }: MicPickerProps) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id} className="text-md">
        {QM_COPY.micPickerLabel}
      </Label>
      <AppSelect
        id={id}
        mode="dropdown"
        variant="bordered"
        size="sm"
        className="h-8"
        searchable={false}
        value={mic.value}
        options={mic.options}
        placeholder={mic.placeholder}
        onChange={mic.choose}
        disabled={disabled}
      />
    </div>
  );
}
